import React, { Component } from 'react';

import ServiceAreaCard from '../../common/cards/service-area-card/ServiceAreaCard';
import { Cell, Grid } from '../../layout';

/**
 * Submitted Income Area
 * This component has the same look and feel as the regular Income Area Section
 * but the data used references the pre-selected values. This component is
 * to be used if you wish to present a user's submission or the people's submission.
 */

class IncomeAreaSectionSubmitted extends Component {

  get isCouncilBudget() {
    return this.props.isCouncilBudget;
  }

  render() {
    const {
      budget, // Selected budget
      councilBudget, // Council info
      changeCouncilCategoryAction,
      isCouncilBudget = false,
      isSummary = false,
    } = this.props;

    const keys = [1];

    return (
      <div className="income-areas-section-main-container-submitted">
        <Grid>
          {
            Object.keys(budget).length > 0 && keys.map(key => {
              // If we are referencing the council object the selected income area value is
              // a boolean. However, an individual budget returns a string of "1" or "0". Therefore,
              // we test the value and return a boolean accordingly to ensure the card is
              // selected correctly.
              const cardStatus = isSummary && isCouncilBudget
                ? councilBudget[`council_${key}`]
                : budget[`council_${key}`].toString() !== '0';


              return (
                <Cell size={{ desktop: '12', tablet: '12', phone: '12' }} key={key}>
                  <ServiceAreaCard
                    k={1}
                    name={councilBudget[`council_${key}_name`]}
                    value={councilBudget[`council_${key}_val`]}
                    info={councilBudget[`council_${key}_info`]}
                    step={councilBudget[`council_${key}_val`] / 10}
                    isSummary={isSummary}
                    status={cardStatus}
                    onChange={(v) => changeCouncilCategoryAction(`council_${key}`, v)}
                  />
                </Cell>
              )
            })
          }
        </Grid>
      </div>
    )
  }
}

export default IncomeAreaSectionSubmitted;



// WEBPACK FOOTER //
// ./src/components/sections/income-areas-section/IncomeAreasSectionSubmitted.jsx